<!-- 商品总账流水列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :ruleFlag ="true" :getRequestData="getRequestData" v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform">
                </vSearch>
            </div>
        </div>
        <!-- <el-tabs> -->
            <!-- <el-tab-pane label="流水信息"> -->
                <div class="page_content_center">
                    <u-table v-if="pageShowData.jurTableVo" :key="$store.state.tableNum" @sort-change="sortChange" size="mini" id="tableData" :data="dataShow" :height="tableHeight" border style="width: 100%" show-summary :summary-method="getSummaries" stripe ref="stockTable"
                        :header-cell-style="{ background: '#fff' }" :row-height="35" row-key="index" use-virtual>
                        <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                            <u-table-column align="center" show-overflow-tooltip v-if="tableValye.isShow == 1 && fixedFields.indexOf(tableValye.entityField) == -1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" :min-width="tableValye.fieldWeight" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'formatter'">
                                        <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                            <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                                                {{ item.value }}
                                            </el-tag>
                                        </span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                            scope.row[tableValye.entityField]
                                        }}</a>
                                    </span>
                                    <span v-else>
                                        {{ scope.row[tableValye.entityField] }}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                        <u-table-column align="center" show-overflow-tooltip label="入库">
                            <u-table-column align="center" show-overflow-tooltip prop="inCount" label="数量" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="inPrice" label="单价" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="inMoney" label="金额" min-width="90px"></u-table-column>
                        </u-table-column>
                        <u-table-column align="center" show-overflow-tooltip label="出库">
                            <u-table-column align="center" show-overflow-tooltip prop="outCount" label="数量" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="outMoney" label="金额" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="endPrice" label="成本价" min-width="90px"></u-table-column>
                        </u-table-column>
                        <u-table-column align="center" show-overflow-tooltip label="结存">
                            <u-table-column align="center" show-overflow-tooltip prop="endCount" label="数量" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="endMoney" label="金额" min-width="90px"></u-table-column>
                            <u-table-column align="center" show-overflow-tooltip prop="endPrice" label="成本价" min-width="90px"></u-table-column>
                        </u-table-column>
                    </u-table>
                </div>
            <!-- </el-tab-pane> -->
        <!-- </el-tabs> -->
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page.sync="currentPage" :page-size.sync="pageSize" :page-sizes="[10,30,100,200,300]"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
    exportRecordAdd
} from "@/service/printApi.js";
export default {
    name: "dataQueryTemplate",
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            pageShowData: [],
            fixedFields: ['inCount', 'inPrice', 'inMoney', 'outCount', 'outMoney', 'endPrice', 'endCount', 'endMoney'],

            getRequestData: {
            },
            activeName: "0",
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            selectedDataIndex: 0,
            reportConditionVos: [],
            reportModuleVos: [],
            tabIndex: 0,
            totalPageData: [],
            dataShow: [],
            // 共几页
            pageNum: 1,
            // 每页显示数量
            pageSize: 10,
            // 当前显示页码
            currentPage: 1,
            // 总共多少条数据
            total: 1,
            // 当前要显示的数据
            pageSizes: [],
            buttonList: [],//按钮数据
            seId: "",//检索Id
            seType: "",//检索名称
            sField: "",//赋值字段
            DialogVisible: false,
            parentSearchData: {},
            seWidth: "",
            seTitle: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        clear(val) {
            if (val) {
                var arr = val.split(",");
                arr.forEach((item) => {
                    this.$set(this.getRequestData, item, "");
                });
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type]

        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        //刷新
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.getButtonList()
                var now = new Date();
                var nowYear = now.getFullYear();
                var nowMonth = now.getMonth();
                var firstDay = new Date(nowYear, nowMonth, 1).getTime();
                this.getRequestData.turnoverDate = firstDay
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 1000, true, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 1000, true, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //打开表单设计
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        //排序
        sortChange(column) {
            this.getRequestData.orderField = column.prop
            if (column.order == 'descending') {
                this.getRequestData.orderType = 1
            } else {
                this.getRequestData.orderType = 0
            }
            this.getDataList()
        },
        //获取按钮列表
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 4:
                    console.log(4);
                    this.getRequestData.ormId = sessionStorage.getItem("ormId")
                    window.location.href = `${this.$store.getters.getConfig.requestUrl}/stockStatistics/exportStockTurnover${this.$common.getUrl(this.getRequestData)}`
                    break;
                default:
                    break;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        //   查询
        searchData() {
            this.tableHeight = this.$common.getTableHeight()
            this.getRequestData.page = 1;
            this.currentPage = 1
            this.getDataList()
        },
        //表格数据写入excel
        export2Excel() {
            this.rpmName = '商品总账流水'; //获取当前导出表格标题
            var nameList = []
            var fieldList = []
            var timeList = []
            this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
                if (item.isShow == 1) {
                    nameList.push(item.showField)
                    fieldList.push(item.entityField)
                    if (item.fieldType == 'date') {
                        timeList.push(item.entityField)
                    }
                }
            })
            // 循环数据列表和时间字段数组 进行转换
            this.returnData.list.forEach((item) => {
                timeList.forEach((timeitem) => {
                    item[timeitem] = this.$common.getLocalTime(item[timeitem]);
                });
            });
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                const tHeader = nameList;
                const filterVal = fieldList;
                const list = this.returnData.list;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, this.rpmName);
            });
            // 导出次数接口
            var token = sessionStorage.getItem("token");
            let params = {
                exportCount: this.returnData.list.length,
                featuresName: this.rpmName
            }
            exportRecordAdd(params, token).then((res) => {
                if (res.status === 200) { }
            });
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        //判断是否求和
        determine(entityField) {
            let arr = ['inCount', 'inPrice', 'inMoney', 'outCount', 'outMoney', 'endPrice', 'endCount', 'endMoney', 'sellMoney', 'sellPrice', 'grossProfit']
            return arr.indexOf(entityField) != -1
        },
        //表格求和
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.determine(column.property)) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.$common.getDecimalInfo(3, prev + curr);
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                }
            });
            this.$nextTick(() => { this.$refs.stockTable.doLayout() })
            return [sums];
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryStockTurnover(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                this.total = this.returnData.list.length;
                this.calcPageData()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },
        // 前端分页逻辑
        calcPageData() {
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.returnData.list.length > 1) {
                this.pageNum = Math.ceil(this.returnData.list.length / this.pageSize) || 1;
            }
            console.log(this.pageNum);
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.returnData.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
            console.log(this.dataShow);
            // this.fullscreenLoading = false
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
    overflow-y: auto;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}
</style>
